<script setup lang="ts">
const props = defineProps<{ vacancy: BaseVacancy }>()

const emits = defineEmits(['refresh'])

const { t } = useI18n({
  useScope: 'local',
})

const isArchived = computed(() => props.vacancy.status == 'archived')

const isArchiveModalOpen = ref(false)
const closeArchiveModal = () => (isArchiveModalOpen.value = false)

const isDeleteModalOpen = ref(false)
const closeDeleteModal = () => (isDeleteModalOpen.value = false)

// const { vacancyTypeName, vacancyTypeNameCapitalized } = useVacancyTypeName(props.vacancy)
</script>

<template>
  <div class="absolute end-0 top-2 z-20">
    <BaseButtonGroup>
      <BaseButton
        :to="`/vacancies/${vacancy.id}/edit`"
        :title="t('editMenuTitle')"
      >
        <Icon name="ph:pen" class="mr-1 size-4" />
        {{ t('editMenuTitle') }}
      </BaseButton>

      <BaseButton
        :title="isArchived ? t('restoreMenuTitle') : t('archiveMenuTitle')"
        @click="isArchiveModalOpen = true"
      >
        <Icon :name="isArchived ? 'ph:arrow-counter-clockwise' : 'ph:archive-duotone'" class="mr-1 size-4" />
        {{ isArchived ? t('restoreMenuTitle') : t('archiveMenuTitle') }}
      </BaseButton>

      <BaseButton
        color="danger"
        :title="t('deleteMenuTitle')"
        @click="isDeleteModalOpen = true"
      >
        <Icon name="ph:trash" class="mr-1 size-4" />
        {{ t('deleteMenuTitle') }}
      </BaseButton>
    </BaseButtonGroup>
  </div>

  <VacancyDetailsDeleteModal
    :open="isDeleteModalOpen"
    :vacancy="vacancy"
    @close="closeDeleteModal"
  />

  <VacancyDetailsArchiveAndRestoreModal
    :key="vacancy.status"
    :open="isArchiveModalOpen"
    :vacancy="vacancy"
    @close="closeArchiveModal"
    @archived="emits('refresh')"
    @restored="emits('refresh')"
  />
</template>

<i18n lang="json">
{
  "en": {
    "editMenuTitle": "Edit",
    "archiveMenuTitle": "Archive",
    "restoreMenuTitle": "Restore",
    "deleteMenuTitle": "Delete"
  },
  "nl": {
    "editMenuTitle": "Bewerken",
    "archiveMenuTitle": "Archiveren",
    "restoreMenuTitle": "Herstellen (de-archiveren)",
    "deleteMenuTitle": "Verwijderen"
  }
}
</i18n>
